import moment from "moment/moment";

import type { Profile } from "./types";
// @ts-expect-error pure js
import { ProfileInviteStatus } from "../../models/profile";

export function getInitials(profile: Profile): string {
  return getInitialsFromName(
    `${profile.prenom ?? ""} ${profile.nom ?? ""}`.trim(),
  );
}

export function getInitialsFromName(name: string): string {
  if (!name) return "";
  const words = name.trim().split(" ", 2);
  if (words.length == 2) {
    return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
}

export function getDisplayName(profile: Profile): string {
  if (parseInt(profile.type as string) === 2 && profile.nom_societe) {
    return profile.nom_societe;
  }
  return `${profile.prenom || ""} ${profile.nom || ""}`.trim();
}

export function getDisplayBirthday(profile: Profile): string | null {
  if (profile.birthday && moment(profile.birthday).isValid()) {
    return moment(profile.birthday).format("DD MMMM YYYY");
  }
  return null;
}

export function getStatusLabel(profile: Profile): string | null {
  if (parseInt(profile.type as string) === 2) {
    return "Société";
  }
  if (profile.status_pro) {
    return profile.status_pro;
  }
  return null;
}

export function getAddress(profile: Profile): string | null {
  if (profile.adresse && profile.cp && profile.ville) {
    return `${profile.adresse} ${profile.cp} ${profile.ville}`;
  }
  return profile.adresse || null;
}

export function isProfileInvitable(profile: Profile): boolean {
  return (
    Boolean(profile.mail) &&
    profile.status_invite !== ProfileInviteStatus.INVITED &&
    profile.status_invite !== ProfileInviteStatus.CONNECTED
  );
}
